"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rotation = void 0;
exports.combineRotations = combineRotations;
exports.parseRotationFromDegrees = parseRotationFromDegrees;
exports.convertToTransform = convertToTransform;
var Rotation;
(function (Rotation) {
    Rotation[Rotation["R0"] = 0] = "R0";
    Rotation[Rotation["R90"] = 90] = "R90";
    Rotation[Rotation["R180"] = 180] = "R180";
    Rotation[Rotation["R270"] = 270] = "R270";
})(Rotation || (exports.Rotation = Rotation = {}));
function combineRotations(rot1, rot2) {
    const result = rot1 + rot2;
    return parseRotationFromDegrees(result);
}
function parseRotationFromDegrees(rot) {
    if (!rot) {
        return Rotation.R0;
    }
    if (typeof rot === 'string') {
        switch (rot) {
            case 'R270':
                return Rotation.R270;
            case 'R180':
                return Rotation.R180;
            case 'R90':
                return Rotation.R90;
            default:
                return Rotation.R0;
        }
    }
    while (rot > 360) {
        rot -= 360;
    }
    switch (rot) {
        case 270:
            return Rotation.R270;
        case 180:
            return Rotation.R180;
        case 90:
            return Rotation.R90;
        default:
            return Rotation.R0;
    }
}
function convertToTransform(r, mirrored) {
    switch (r) {
        case Rotation.R270:
            return { rot: 270, sx: 1, sy: mirrored ? -1 : 1 };
        case Rotation.R180:
            return { rot: 180, sx: mirrored ? -1 : 1, sy: 1 };
        case Rotation.R90:
            return { rot: 90, sx: 1, sy: mirrored ? -1 : 1 };
        default:
            return { rot: 0, sx: mirrored ? -1 : 1, sy: 1 };
    }
}
//# sourceMappingURL=Rotation.js.map